// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Rme1z","colMin":"styles_colMin__2g3i6","colCheckbox":"styles_colCheckbox__5hyVN"};